import { checkHasAccess } from "./checkHasAccess";
import { getAccessRightByAccessType } from "./getAccessRightByAccessType";

import { ENav } from "components/Layout/types";
import { EAccessType, TBooleanRecord } from "types";
import {
  ENAV_TYPE,
  TAB_LIST,
  TAB_LIST_ACCESSRIGHT,
} from "components/Layout/constants";

export const getAllowedTabList = ({
  corpAccessRight,
  buAccessRight,
  communityAccessRight,
  accessType,
  isSuperAdmin,
}: {
  corpAccessRight?: TBooleanRecord;
  buAccessRight?: TBooleanRecord;
  communityAccessRight?: TBooleanRecord;
  accessType?: EAccessType;
  isSuperAdmin?: boolean;
}) => {
  if (accessType === undefined || accessType === EAccessType.EMPTY) {
    return TAB_LIST;
  }
  const accessRight = getAccessRightByAccessType({
    accessType,
    buAccessRight,
    corporationAccessRight: corpAccessRight,
    communityAccessRight,
  });

  const currentNav = ENAV_TYPE?.[accessType] || ENav.PERSONAL;

  let finalTabList: Record<
    string,
    Record<string, string | Record<string, string>>
  > = {};

  for (const navTabItem in TAB_LIST_ACCESSRIGHT) {
    const pathValue = TAB_LIST_ACCESSRIGHT[navTabItem][currentNav];

    // Continue to the next loop if pathvalue is not exist in the current active nav
    if (pathValue === undefined) continue;

    if (
      (Array.isArray(pathValue) && !pathValue?.length) ||
      pathValue === null ||
      (typeof pathValue === "string" && isSuperAdmin)
    ) {
      finalTabList = {
        ...finalTabList,
        [navTabItem]: {
          ...finalTabList?.[navTabItem],
          [currentNav]: TAB_LIST[navTabItem][currentNav],
        },
      };
      continue;
    }

    if (pathValue?.length) {
      const hasAccess = checkHasAccess(pathValue as number[], accessRight);

      if (hasAccess) {
        finalTabList = {
          ...finalTabList,
          [navTabItem]: {
            ...finalTabList?.[navTabItem],
            [currentNav]: TAB_LIST[navTabItem][currentNav],
          },
        };
      }
      continue;
    }

    if (typeof pathValue === "object") {
      for (const keyChild in pathValue) {
        const childPathValue = (pathValue as any)?.[keyChild];
        let passedAccessRightCheck = false;

        if (childPathValue?.length) {
          passedAccessRightCheck = checkHasAccess(
            childPathValue as number[],
            accessRight
          );
        }

        if (!childPathValue?.length || passedAccessRightCheck) {
          finalTabList = {
            ...finalTabList,
            [navTabItem]: {
              ...finalTabList?.[navTabItem],
              [currentNav]: {
                ...(finalTabList?.[navTabItem]?.[currentNav] as object),
                [keyChild]: (TAB_LIST[navTabItem][currentNav] as any)[
                  keyChild
                ] as string,
              },
            },
          };
        }
      }
    }
  }

  return finalTabList;
};
